<template>
    <v-container grid-list-md fluid>
        <v-layout wrap ml-3>
            <v-btn-back @click="$router.go(-1)"> </v-btn-back>
        </v-layout>
        <v-card class="default_card large" v-if="mail" elevation="0">
            <v-card-title>
                {{ mail.subject }}
            </v-card-title>
            <v-card-title>
                <strong>{{ mail.from }}</strong>
                <v-spacer />
                <span>{{ formatDate(mail.date) }}</span>
            </v-card-title>
            <v-card-subtitle class="pt-1">A {{ mail.to }}</v-card-subtitle>
            <v-card-text>
                <div
                    v-html="mail.textAsHtml"
                    v-if="mail.textAsHtml"
                    style="background-color: #fff !important; border-radius: 6px"
                    class="pa-6"
                />
                <div
                    v-else
                    style="background-color: #fff !important; border-radius: 6px"
                    class="pa-6"
                >
                    {{ mail.text }}
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";

import MAIL_QUERY from "../../graphql/mail/Mail.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class Mail extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) id: string;

    formatDate(date) {
        return moment(date).format("DD/MM/YYYY");
    }

    @Apollo({
        query: MAIL_QUERY,
        variables() {
            return {
                id: this.id,
            };
        },
        skip() {
            return !this.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.mail) {
                    this.mail = data.mail;
                } else {
                    this.mail = null;
                }
            }
        },
    })
    mail: any = null;
}

export default toNative(Mail);
</script>
